// extracted by mini-css-extract-plugin
export default {"EUVATContainer":"euvatrate_EUVATContainer__27muK","euvatul":"euvatrate_euvatul__k7uxj","detailEUVAT":"euvatrate_detailEUVAT__9lp+p"};